'use client';

import { c as _c } from "react/compiler-runtime";
import { aspCond } from '@module/helpers/conditions/condition';
import { cn } from '@module/lib/utils';
import useIsMounted from '@module/utils/useIsMounted';
import RouteTabs from '@pc/components/molecules/tab/RouteTabs';
import RouteTabsItem from '@pc/components/molecules/tab/RouteTabsItem';
function CustomerNav() {
  const $ = _c(4);
  const isMounted = useIsMounted();
  if (!isMounted) {
    return null;
  }
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("flex justify-center h-full w-[860px]", {
      "justify-start pl-10": aspCond.if("asp")
    });
    t1 = aspCond.if("asp") ? <><RouteTabsItem className="mr-4 border-b-primaryFg p-0" path="/customer/inquire" isAuthCheck={true}>{"1:1\uBB38\uC758"}</RouteTabsItem><RouteTabsItem className="mr-4 border-b-primaryFg p-0" path="/customer/event">{"\uC774\uBCA4\uD2B8"}</RouteTabsItem></> : <><RouteTabsItem className="mr-4 border-b-primaryFg p-0" subPath="/illegalDistribution" path="/customer/claim">{"\uC2E0\uACE0\uC13C\uD130"}</RouteTabsItem><RouteTabsItem className="mr-4 border-b-primaryFg p-0" path="/customer/faq">{"\uC790\uC8FC\uD558\uB294 \uC9C8\uBB38"}</RouteTabsItem><RouteTabsItem className="mr-4 border-b-primaryFg p-0" path="/customer/inquire" isAuthCheck={true}>{"1:1\uBB38\uC758"}</RouteTabsItem><RouteTabsItem className="mr-4 border-b-primaryFg p-0" path="/customer/notice">{"\uACF5\uC9C0\uC0AC\uD56D"}</RouteTabsItem><RouteTabsItem className="mr-4 border-b-primaryFg p-0" path="/customer/event">{"\uC774\uBCA4\uD2B8"}</RouteTabsItem><RouteTabsItem className="mr-4 border-b-primaryFg p-0" path="/customer/freeCoin" subPath="/1" isAuthCheck={true}>{"\uBB34\uB8CC\uD558\uD2B8"}</RouteTabsItem><RouteTabsItem className="mr-4 border-b-primaryFg p-0" path="/customer/guide/pc/external" matchingPaths={["/customer/guide"]}>{"\uBC29\uC1A1\uAC00\uC774\uB4DC"}</RouteTabsItem><RouteTabsItem className="mr-0 border-b-primaryFg p-0" path="/customer/emoticon/normal" matchingPaths={["/customer/emoticon"]}>{"\uD558\uD2B8\uC774\uBAA8\uD2F0\uCF58"}</RouteTabsItem></>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t0) {
    t2 = <RouteTabs className="w-[860px] items-center" contentClassName={t0}>{t1}</RouteTabs>;
    $[2] = t0;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export default CustomerNav;